import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHCargoGet = async (credentials, data) => {
  const body = {
    service: "RNHCargoGet",
    params: {
      rnhCargoId: data?.id || null,
      rnhCargoCod: data?.cod || null,
      rnhCargoComponenteId: data?.componenteId || null,
      rnhTipoComponenteCod: data?.componenteCod || null,
      rnhTipoComponenteNombre: data?.componenteNombre || null,
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));

};
